import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./ProductReportSummary.module.css";
import { useSelector } from "react-redux";

const ProductReportSummary = ({
  showAutoComplete = () => {},
  refreshData = () => {},
  refreshRef,
  addRef,
  uploadRef,
  uploadData = () => {},
  downloadRef,
  downloadData = () => {},
}) => {
  const { data } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer?.activeTabIndex]
  );
  const rowCount = data?.rows ? data.rows.length : 0;
  return (
    <div className={classes["summary-container"]}>
        <div className={classes["summary-totals"]}>
        <FilterGroup align="vertical">
          <FilterItem>
            <div className={classes["summary-label"]}>Count</div>
          </FilterItem>
          <FilterItem>
            <div className={classes["summary-value"]}>{rowCount}</div>
          </FilterItem>
        </FilterGroup>
      </div>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              ref={uploadRef}
              label="Upload"
              color="black"
              onClick={() => {
                uploadData();
              }}
              endIcon={<Shortcut keys={["Alt", "U"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={downloadRef}
              label="Download"
              color="black"
              onClick={() => {
                downloadData();
              }}
              endIcon={<Shortcut keys={["Alt", "D"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={addRef}
              label="Add New Product"
              color="violet"
              onClick={showAutoComplete}
              endIcon={<Shortcut keys={["Ctrl", "M"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default ProductReportSummary;
